var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from 'react';
import ModuleHeader from '../../components/ModuleHeader/ModuleHeader';
import ModuleTable from '../../components/UtilityComponents/moduleTable';
import { AdminManagementCols } from '../../config/TableColumns';
import { Box } from '@mui/material';
import moment from 'moment';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import AdminModuleDrawer from './AdminModuleDrawer';
import { useSelector } from 'react-redux';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { utility } from '../../utils';
var AdminManagement = function () {
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var adminPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'ADMINISTRATOR:ADMIN_MGMT:USERS'; });
    var canView = (adminPermission === null || adminPermission === void 0 ? void 0 : adminPermission.View) === 1;
    var canAdd = (adminPermission === null || adminPermission === void 0 ? void 0 : adminPermission.Add) === 1;
    var canUpdate = (adminPermission === null || adminPermission === void 0 ? void 0 : adminPermission.Update) === 1;
    var canDelete = (adminPermission === null || adminPermission === void 0 ? void 0 : adminPermission.Delete) === 1;
    var _a = useState(), searchText = _a[0], setSearchText = _a[1];
    var _b = useState(''), selectedRoleFilter = _b[0], setSelectedRoleFilter = _b[1];
    var _c = useState([]), adminList = _c[0], setAdminList = _c[1];
    var _d = useState([]), freezedList = _d[0], setFreezedList = _d[1];
    var _e = useState(false), isFetching = _e[0], setIsFetching = _e[1];
    var _f = useState(), rowData = _f[0], setRowData = _f[1];
    var _g = useState(false), open = _g[0], setOpen = _g[1];
    var _h = useState(''), userAction = _h[0], setUserAction = _h[1];
    var _j = useState(false), openConfirmationPopup = _j[0], setOpenConfirmationPopup = _j[1];
    var _k = useState(false), openSuccessPopup = _k[0], setOpenSuccessPopup = _k[1];
    var _l = useState([{ label: 'All', value: '' }]), roleOptions = _l[0], setRoleOptions = _l[1];
    var getAdminList = function () {
        setIsFetching(true);
        setAdminList([]);
        api_service.get({
            endPoint: api_urls.ADMIN_LIST,
        }).then(function (res) {
            setIsFetching(false);
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __adminList = res.data.data;
                __adminList.map(function (eachDealer, index) {
                    eachDealer.CreatedTime = moment(eachDealer.CreatedTime).tz('America/New_York');
                    eachDealer.AdminStatus = eachDealer.Status ? eachDealer.Status == 2 ? 2 : 1 : 0;
                });
                setAdminList(__adminList);
                setFreezedList(__adminList);
            }
        }).catch(function (err) { setIsFetching(false); });
    };
    var getRolesList = function () {
        api_service.get({
            endPoint: api_urls.ROLES_LIST,
            payLoad: { PortalType: 'ADMIN' }
        }).then(function (res) {
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                var __rolesList = res.data.data.map(function (item) {
                    return { label: item.RoleDescription, value: item.RoleDescription };
                });
                setRoleOptions(__spreadArray([{ label: 'All', value: '' }], __rolesList, true));
            }
        }).catch(function (err) {
            console.log('getRolesList ~ err:', err);
        });
    };
    var tableActionHandler = function (rowData, actionType) {
        if (actionType === 'Edit' && !canUpdate) {
            utility.alert('You do not have permission to edit admin users', 'error');
            return;
        }
        setRowData(rowData);
        if (actionType === 'Edit') {
            setUserAction('Edit');
            setOpen(true);
        }
        else if (actionType === 'sendTempPasswordLink') {
            setOpenConfirmationPopup(true);
        }
    };
    var handleSendTemporaryPasswordLink = function () {
        api_service.post({
            endPoint: api_urls.RESEND_PASSWORD_LINK,
            payLoad: {
                AccountId: rowData === null || rowData === void 0 ? void 0 : rowData.Id
            },
            showLoader: true
        }).then(function (res) {
            var _a;
            if ((res === null || res === void 0 ? void 0 : res.data) && res.data.statusCode === 200) {
                setOpenSuccessPopup(true);
            }
            else {
                utility.alert((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.message);
            }
            setRowData(null);
        }).catch(function (err) {
            console.log("🚀 ~ handleSendTemporaryPasswordLink ~ err:", err);
        });
    };
    var handleViewDetails = function (__rowData) {
        setRowData(__rowData);
        setUserAction('View');
        setOpen(true);
    };
    var handleCreateAdmin = function () {
        if (!canAdd) {
            utility.alert('You do not have permission to create admin users', 'error');
            return;
        }
        setUserAction('Create');
        setOpen(true);
    };
    var handleClose = function () {
        setRowData(null);
        setOpen(false);
        setUserAction('');
    };
    useEffect(function () {
        var searchTerm = (searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()) || '';
        var filteredResults = freezedList;
        if (searchTerm !== '') {
            filteredResults = filteredResults.filter(function (item) {
                return item.FirstName.toLowerCase().includes(searchTerm) ||
                    item.RoleDescription.toLowerCase().includes(searchTerm) ||
                    item.Email.toLowerCase().includes(searchTerm);
            });
        }
        if (selectedRoleFilter) {
            filteredResults = filteredResults.filter(function (item) {
                return item.RoleDescription === selectedRoleFilter;
            });
        }
        setAdminList(filteredResults);
    }, [searchText, selectedRoleFilter, freezedList]);
    useEffect(function () {
        getAdminList();
        getRolesList();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: 'Are you sure?', message: "Are you sure you want to send the temporary password link?", acceptBtnText: 'Yes', denyBtnText: 'No', acceptCallBack: useCallback(function () {
                handleSendTemporaryPasswordLink();
                setOpenConfirmationPopup(false);
            }, [openConfirmationPopup]), denyCallBack: useCallback(function () {
                setOpenConfirmationPopup(false);
            }, []), open: openConfirmationPopup, key: "".concat(openConfirmationPopup), cancelCallBack: useCallback(function () {
                setOpenConfirmationPopup(false);
            }, []) }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: 'Success!', message: "Temporary Password link has been sent successfully.", acceptBtnText: 'Ok', acceptCallBack: useCallback(function () {
                setOpenSuccessPopup(false);
            }, [openConfirmationPopup]), open: openSuccessPopup, key: "".concat(openSuccessPopup) }),
        React.createElement(Box, { className: "common-module-wrapper admin-management-wrapper" },
            React.createElement(ModuleHeader, { moduleName: 'Admin Users', placeHolderText: 'Search by Name/Role/Email', hasPortalDD: false, hasStatusDD: false, hasSearch: true, hasRoleFilter: true, selectedRoleFilter: selectedRoleFilter, onRoleFilterChange: function (event, value) { var _a; return setSelectedRoleFilter((_a = value === null || value === void 0 ? void 0 : value.value) !== null && _a !== void 0 ? _a : ''); }, roleOptions: roleOptions, getSelectedPortal: function () { }, selectedStatus: function () { }, getSearchedText: setSearchText, isDrawerOpen: function () { return handleCreateAdmin(); }, feildWidth: 3.5, sx: { position: "sticky", zIndex: 3 } }),
            React.createElement(Box, { className: "module-common-table-wrapper" },
                React.createElement(ModuleTable, { dataToDisplay: adminList, columns: AdminManagementCols, isLoading: isFetching, actionHandler: tableActionHandler, onClickHandler: handleViewDetails, isRowClickEnabled: canView, moduleName: "Admin Management", hideEditIcon: !canUpdate, hasDelete: canDelete, isActionColumn: canUpdate })),
            React.createElement(Box, null,
                React.createElement(AdminModuleDrawer, { open: open, handleClose: handleClose, rowData: rowData, userAction: userAction, getAdminList: getAdminList, canUpdate: canUpdate })))));
};
export default AdminManagement;
